<payee-chip-dropdown
  [selected]="value"
  [placeholder]="'Név'"
  [(dropdownOpen)]="dropdownOpen"
  (removed)="removed()"
>
  <payee-form-field width="wide">
    <input
      payee-input
      placeholder="Név"
      [formControl]="formControl"
    />
  </payee-form-field>
</payee-chip-dropdown>
